'use client';

import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { SITE } from '@/app/constants';
import { cn, getSubscriptionUrl, reportEvent } from '@/app/utils';
import { useLocale, useRouter } from '@/i18n/routing';

const BANNER_ASSETS =
  SITE === 'global'
    ? {
        bg: 'https://image01.cf.vidu.studio/vidu/media-asset/s1_bg-1d745d40.webp',
        cards: 'https://image01.cf.vidu.studio/vidu/media-asset/s1_icon-cc57ff6c.webp',
      }
    : {
        bg: 'https://image01-aliyun.vidu.zone/vidu/media-asset/s1_bg-1d745d40.webp',
        cards: 'https://image01-aliyun.vidu.zone/vidu/media-asset/s1_icon-cc57ff6c.webp',
      };

const COPY = {
  zh: {
    lead: '低至 $4.99，畅享 7 天 VIP 会员，首月再享 8.5 折',
    cta: '立即购买',
  },
  en: {
    lead: 'From $4.99, enjoy 7 days of VIP access, plus 15% off your first month.',
    cta: 'Buy Now',
  },
};

export const Vidu7DTrialBanner = ({ onClose, className }: { onClose: () => void; className?: string }) => {
  const locale = useLocale();
  const router = useRouter();
  const copy = COPY[locale === 'zh' ? 'zh' : 'en'];

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    reportEvent('element_click', { element_name: 'vidu_7d_trial_top_banner_close' });
    onClose();
  };

  const goVidu7DTrial = (elementName: string) => {
    reportEvent('element_click', { element_name: elementName });
    router.push(getSubscriptionUrl(false, 'tab=plan&subscription-period=paid_trial'));
  };

  const handleBarClick = () => {
    goVidu7DTrial('vidu_7d_trial_top_banner_main');
  };

  const handleCtaClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    goVidu7DTrial('vidu_7d_trial_top_banner_cta');
  };

  return (
    <div
      className={cn(
        'relative isolate flex h-[60px] w-full cursor-pointer items-center justify-between overflow-hidden bg-[rgba(47,51,83,0.5)] px-4',
        className,
      )}
      onClick={handleBarClick}
    >
      <div className="pointer-events-none absolute inset-0">
        <img src={BANNER_ASSETS.bg} alt="" className="h-full w-full object-cover" />
      </div>

      <div className="relative z-10 flex h-full min-w-0 flex-1 items-center justify-center gap-3 overflow-hidden">
        <div className="flex h-full min-w-0 items-center gap-2 overflow-hidden whitespace-nowrap text-sm text-white leading-[1.4]">
          <img
            src={BANNER_ASSETS.cards}
            alt=""
            width={90}
            height={48}
            className="mr-1 h-12 w-[90px] shrink-0 self-end sm:hidden"
          />
          <span className="min-w-0 truncate">{copy.lead}</span>
        </div>

        <div className="h-[14px] w-px shrink-0 bg-system-white16 sm:hidden" />

        <button
          type="button"
          onClick={handleCtaClick}
          className="shrink-0 cursor-pointer rounded-[8px] border-0 bg-black px-3 py-1 font-semibold text-white text-xs leading-[1.4] transition-colors hover:bg-black/80 sm:hidden"
        >
          {copy.cta}
        </button>
      </div>

      <button
        type="button"
        onClick={handleClose}
        className="relative z-10 shrink-0 text-white transition-colors hover:text-white/80"
        aria-label="Close"
      >
        <BaseLineClose className="size-4" />
      </button>
    </div>
  );
};
